<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title primary-title>
            <span class="headline mb-0">諸掛費用登録（詳細）</span>
          </v-card-title>
          <v-card-actions>
            <v-btn
              :disabled="hasConfirmed || !isOtherChargeValid"
              @click="save"
              v-permit.SHARP_LFD_SAVE
              >確認保存</v-btn
            >
            <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-form>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    :value="shipment.doNo"
                    disabled
                    id="txt-DO-No"
                    label="D/O NO"
                    name="doNo"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    :label="$t('app.labels.blNo')"
                    :value="shipment.blNo"
                    disabled
                    id="txt-BL-No"
                    name="blNo"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md3>
                  <remote-autocomplete
                    :disabled="true"
                    :label="$t('app.labels.loadingPort')"
                    id="txt-DO-No"
                    name="loadingPort"
                    url="ports/kv"
                    v-model="shipment.loadingPortCode"
                  />
                </v-flex>
                <v-flex md3>
                  <remote-autocomplete
                    :disabled="true"
                    :label="$t('app.labels.dischargePort')"
                    id="txt-BL-No"
                    name="blNo"
                    url="ports/kv"
                    v-model="shipment.dischargePortCode"
                  />
                </v-flex>
                <v-flex md3>
                  <date-picker
                    :disabled="true"
                    :label="$t('app.labels.etd')"
                    :value="shipment.etd"
                    id="txt-etd"
                    name="etd"
                  />
                </v-flex>
                <v-flex md3>
                  <date-picker
                    :disabled="true"
                    :label="$t('app.labels.eta')"
                    :value="shipment.eta"
                    id="txt-eta"
                    name="eta"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <info-for-sjl :shipment="shipment" />
      </v-flex>

      <v-flex xs12>
        <v-card class="mt-2">
          <v-card-title>費用詳細</v-card-title>
          <v-card-text>
            <div :key="supplier.id" v-for="(supplier, index) in suppliers">
              <v-layout row wrap>
                <v-flex md3 sm6 xs12>
                  <v-checkbox
                    :label="supplier.name"
                    :value="supplier.id"
                    class="selectCharge"
                    v-model="selected"
                  />
                </v-flex>
                <v-flex md1 sm12 style="margin-top: 20px" xs12>
                  <v-btn
                    :disabled="!canChangeSupplier(supplier.id)"
                    @click="popup(supplier, index)"
                    v-permit.SHARP_LOCAL_DO_FEE_SUPPLIER_CHANGE
                  >
                    取引先变更
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex
                  md1
                  sm12
                  style="margin-top: 20px; margin-left: 40px"
                  xs12
                >
                  <v-btn
                    :disabled="!canAgreeSupplier(supplier.id)"
                    @click="agree(supplier)"
                    v-permit.SHARP_LFD_CONFIRM
                    >承認</v-btn
                  >
                </v-flex>
                <v-flex md1 sm12 style="margin-top: 20px" xs12>
                  <v-btn
                    :disabled="!canAgreeCancel(supplier.id)"
                    @click="turnBack(supplier)"
                    v-permit.SHARP_LOCAL_DO_FEE_CONFIRM_CANCEL
                    >承認取消</v-btn
                  >
                </v-flex>

                <!-- <v-flex md1 sm12 style="margin-top:20px;" xs12>
                  <v-btn @click="turnBack(supplier)">承認取消</v-btn>
                </v-flex>-->
              </v-layout>

              <summary-charges
                :shipment="shipment"
                :supplierId="supplier.id"
                @adjust="change"
                columns="15,16,17,11,2,3,4,12,13,14,8,9,19,18"
                ref="summary"
                v-if="shipment.isFCL"
              ></summary-charges>
              <summary-charges
                :shipment="shipment"
                :supplierId="supplier.id"
                @adjust="change"
                columns="15,16,17,11,2,3,4,12,13,14,8,9"
                ref="summary"
                v-if="!shipment.isFCL"
              ></summary-charges>
            </div>
          </v-card-text>
        </v-card>
        <v-card class="mt-2" v-permit.SHARP_LFD_SAVE v-if="!shipment.isDapDdp">
          <v-card-title>費用詳細</v-card-title>
          <v-card-text>
            <v-form v-model="isOtherChargeValid">
              <edit-charges
                :exchangeRateDate="new Date().format('yyyy-MM-dd')"
                :shipment="shipment"
                :taxDate="
                  shipment.deliveryOrders
                    .filter((i) => !i.isSplit)
                    .map((i) => i.forecastDeliveryDate)
                    .filter((i) => i != null)[0]
                "
                columns="0,1,2,5,3,6,7,8"
                exchangeRateScope="INTERNAL"
                scope="2"
              />
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      :key="`append-cost-delivery-${key}`"
      row
      v-for="(deliveryOrder, key) in shipment.deliveryOrders
        .filter((i) => !i.isSplit)
        .sort(sortByBranchCode)"
      wrap
    >
      <v-flex v-permit.SHARP_LFD_CONFIRM xs6>
        <v-card>
          <v-card-title>追加費用</v-card-title>
          <v-card-text>
            <list-charges
              :shipment="deliveryOrder"
              columns="20,0,21,5,9,22,8"
              scope="1"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex v-permit.SHARP_LFD_CONFIRM xs6>
        <delivery :shipment="deliveryOrder" />
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title>業者変更</v-card-title>
        <v-container fluid>
          <v-card-text>
            <remote-autocomplete
              label="業者"
              url="companies/supplier"
              v-model="adjustedSupplierId"
            ></remote-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="changeSupplier">変更</v-btn>
            <v-btn @click="dialog = false">戻る</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import InfoForSjl from './InfoForSjl'
import delivery from './DeliveryPattern'
import SummaryCharges from './SummaryCharges'
export default {
  components: {
    InfoForSjl,
    delivery,
    SummaryCharges,
  },
  data() {
    return {
      isOtherChargeValid: false,
      shipment: { summaryCharges: [], deliveryOrders: [] },
      selected: [],
      dialog: false,
      originSupplierId: null,
      adjustedSupplierId: null,
      currentIndex: null,
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    sortByBranchCode() {
      return (a, b) => parseInt(a.branchCode) - parseInt(b.branchCode)
    },
    hasConfirmed() {
      return (
        this.shipment.summaryCharges.filter((i) => i.status === '1').length > 0
      )
    },
    suppliers() {
      return this.shipment.summaryCharges.reduce((ss, i) => {
        let supplier = ss.find((s) => s.id === i.supplierId)
        if (!supplier) {
          return [...ss, { id: i.supplierId, name: i.supplierName }]
        } else {
          return ss
        }
      }, [])
    },
    isLocalApproveArchive() {
      return this.shipment.isLocalApproveArchive
    },
  },
  methods: {
    hasNeedApproved(supplierId) {
      return (
        this.shipment.summaryCharges
          .filter((i) => !i.isDefaultApproved)
          .filter((i) => i.supplierId === supplierId).length > 0
      )
    },
    hasSupplierUnConfirmed(supplierId) {
      return (
        this.shipment.summaryCharges
          .filter((i) => !i.isDefaultApproved)
          .filter((i) => i.supplierId === supplierId)
          .filter((i) => i.status !== '1').length > 0
      )
    },
    isDestinationCharge(supplierId) {
      return (
        this.shipment.summaryCharges
          .filter((i) => i.isDestinationCharge)
          .filter((i) => i.supplierId === supplierId).length > 0
      )
    },
    canChangeSupplier(supplierId) {
      return (
        !this.isLocalApproveArchive &&
        this.hasSupplierUnConfirmed(supplierId) &&
        !this.isDestinationCharge(supplierId)
      )
    },
    canAgreeSupplier(supplierId) {
      return (
        !this.isLocalApproveArchive && this.hasSupplierUnConfirmed(supplierId)
      )
    },
    canAgreeCancel(supplierId) {
      return (
        !this.isLocalApproveArchive &&
        !this.hasSupplierUnConfirmed(supplierId) &&
        this.hasNeedApproved(supplierId)
      )
    },
    canAdjustSupplier(supplier) {
      return this.shipment.chargeApprovalStatus === '諸掛承認済'
    },
    turnBack(supplier) {
      this.$confirm({
        content: '【業者登録済】に戻ってよろしいでしょうか？',
      })
        .then(() => {
          this.$http
            .put(
              `/shipping-advices/${this.$route.query.id}/back-to-unconfirmed`,
              {
                suppliers: [supplier.id],
              }
            )
            .then(() => {
              this.$message('', '承認取消が完了しました。')
              this.load()
              this.selected = []
            })
            .catch((res) => {
              if (res.response.status === 500) {
                // if (res.response.data.message == 'CAN_NOT_TURN_BACK') {
                //   this.$message(
                //     this.$t('app.messages.errors.title'),
                //     '該当諸掛費用が凍結されたため、承認取消ができません。'
                //   )
                // } else
                if (res.response.data.message == 'DATA_FROZEN') {
                  this.$message(
                    this.$t('app.messages.errors.title'),
                    '該当諸掛費用が凍結されたため、承認取消ができません。'
                  )
                } else {
                  this.$message(
                    this.$t('app.messages.errors.title'),
                    '承認取消が失敗しました。'
                  )
                }
              }
            })
        })
        .catch(() => {})
    },
    popup(supplier, index) {
      this.dialog = true
      this.originSupplierId = supplier.id
      this.currentIndex = index
    },
    change(item) {
      this.$http
        .put('/delivery-orders/adjust-supplier', {
          adjustKeys: item.map(
            (s) =>
              s.shipmentId +
              ':' +
              s.chargeItemScreenStatistics +
              ':' +
              s.chargeItemTypeCode
          ),
          originSupplierId: this.originSupplierId,
          adjustedSupplierId: this.adjustedSupplierId,
          saId: this.$route.query.id,
        })
        .then(() => {
          this.$message('', '変更が完了しました。')
          this.load()
          this.selected = []
          this.dialog = false
        })
        .catch((res) => {
          if (res.response.status === 500) {
            if (res.response.data.message == 'INVALID_STATUS') {
              this.$message(
                this.$t('app.messages.errors.title'),
                '該当諸掛費用が承認済のため、取引先変更ができません。'
              )
            } else if (res.response.data.message == 'ADJUSTED_INVALID_STATUS') {
              this.$message(
                this.$t('app.messages.errors.title'),
                '変更先が既に承認済のため、承認取り消してください。'
              )
            } else {
              this.$message(
                this.$t('app.messages.errors.title'),
                '取引先変更が失敗しました。'
              )
            }
          }
        })
    },
    changeSupplier() {
      this.$refs.summary
        .filter((e) => e.supplierId === this.originSupplierId)
        .map((e) => e.adjustSupplier())
      // this.$refs.summary[this.currentIndex].adjustSupplier()
    },
    load() {
      this.$http
        .get(`shipping-advices/${this.$route.query.id}?view=B1101`)
        .then((res) => {
          var ingored = ['商品代金', 'SJL Commission', '保険費']
          this.shipment = {
            ...res.data,
            summaryCharges: this.combineSummaryCharges(res.data)
              .filter(
                (c) => ingored.indexOf(c.chargeItemScreenStatistics) == -1
              )
              .filter((c) => !(c.isDestinationCharge && c.supplierId === null))
              .sort((a, b) => this.sortWithNull(a.supplierId, b.supplierId)),
          }
          return this.shipment
        })
    },
    sortWithNull(a, b) {
      if (a === null || a === undefined) {
        a = ''
      }
      if (b === null || b === undefined) {
        b = ''
      }
      return a.localeCompare(b)
    },
    combineSummaryCharges(data) {
      let saCharges = data.summaryChargesBySupplier
      let saScreenStatistics = saCharges.map(
        (i) => i.chargeItemScreenStatistics
      )

      return [
        ...data.deliveryOrders
          .filter((i) => !i.isSplit)
          .map((i) => i.summaryChargesBySupplier)
          .reduce((x, y) => [...x, ...y], [])
          .filter(
            (i) =>
              saScreenStatistics.indexOf(i.chargeItemScreenStatistics) === -1
          ),
        ...saCharges,
      ]
    },
    save() {
      this.$http
        .put(`shipping-advices/${this.$route.query.id}/charges`, this.shipment)
        .then(this.load)
        .then(() => {
          this.$message('Info', '確認保存が完了しました。')
        })
        .catch((res) => {
          if (res.response.data.message == 'EXCHANGE_RATE_NOT_FOUND') {
            this.$message(
              this.$t('app.messages.errors.title'),
              'その他諸掛に登録する通貨が為替レートに登録されていません。通貨が正しいかどうかをご確認ください。'
            )
          }
        })
    },
    agree(supplier) {
      this.$http
        .put(`shipping-advices/${this.$route.query.id}/agree`, {
          suppliers: [supplier.id],
        })
        .then(() => {
          this.load()
          this.$message('Info', '承認が完了しました。')
          this.selected = []
        })
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
.selectCharge {
  margin-left: 17px;
}
</style>
